import React, { Suspense, useState, useEffect } from 'react'
import './App.scss'
import Nav from 'components/nav/Nav'
import { I18N } from 'components/i18n/I18n'
import { ErrorBoundary } from './ErrorBoundary'
import { NavStateContext } from 'assets/useNavState'
import { URL, useAPI } from './api'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
// setup sentry, google analytics, etc.
import './setupApp'
import { ArcThemeProvider } from '@arc-ui/core'

const Applications = React.lazy(() => import('components/applications'))
const TrendingContent = React.lazy(() => import('components/trending-content'))
const ProfileSettings = React.lazy(() => import('components/profile-settings'))
const DevTools = React.lazy(() => import('react-async-devtools'))

export function App() {
  const [isNavOpen, setNavOpen] = useState<boolean>() // We require another state value so that we can continue to show Trending Content or Tiles view even if the user clicks the nav button.
  const [showTrendingContent, setshowTrendingContent] = useState<boolean>()
  const [integrationType, setIntegrationType] = useState<string>()

  const {
    isPending: integrationsPromisePending,
    data: integrationsData,
    isRejected: integrationsRejected,
  } = useAPI(URL.settings.getIntegrations)

  const {
    isPending: permissionPromisePending,
    data: permissionsData,
    isRejected: permissionsRejected,
  } = useAPI(URL.trident.getPermissions)

  useEffect(() => {
    const { permissions } = (permissionsData as any) || {}
    
    if (!integrationsPromisePending && !permissionPromisePending) {
      if (integrationsRejected || permissionsRejected) {
        setNavOpen(false)
        setshowTrendingContent(false)
      } else if (
        permissions &&
        permissions['Arc Home'] &&
        permissions['Arc Home'].global &&
        permissions['Arc Home'].global.includes('TCM') &&
        integrationsData.count > 0 &&
        integrationsData.rows &&
        integrationsData.rows[0] &&
        integrationsData.rows[0].type
      ) {
        setNavOpen(true)
        setshowTrendingContent(true)
        setIntegrationType(integrationsData.rows[0].type)
      } else {
        setNavOpen(false)
        setshowTrendingContent(false)
      }
    }
  }, [
    integrationsPromisePending,
    permissionPromisePending,
    integrationsRejected,
    permissionsRejected,
    permissionsData,
    integrationsData,
  ])

  return (
    <ArcThemeProvider>
      <I18N>
        <Router>
          <Switch>
            <Route path="/home/profile/settings/">
              <NavStateContext.Provider value={[false, setNavOpen]}>
                <Nav />
                <ErrorBoundary>
                  <Suspense fallback={<div />}>
                    <ProfileSettings />
                  </Suspense>
                </ErrorBoundary>
              </NavStateContext.Provider>
            </Route>
            <Route>
              {isNavOpen !== undefined && (
                <NavStateContext.Provider value={[isNavOpen, setNavOpen]}>
                  <Nav />
                  <ErrorBoundary>
                    <Suspense fallback={<div />}>
                      {showTrendingContent ? (
                        <TrendingContent integrationType={integrationType} />
                      ) : (
                        <Applications />
                      )}
                    </Suspense>
                  </ErrorBoundary>
                  {process.env.USE_DEVTOOLS && <DevTools />}
                </NavStateContext.Provider>
              )}
            </Route>
          </Switch>
        </Router>
      </I18N>
    </ArcThemeProvider>
  )
}
